import { useEffect, useRef, useState } from "react";
import { services } from "@/mocks/celesteTarot";

export default function ServicesSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.15 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  const handleContact = () => {
    const el = document.querySelector("#contacto");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="servicios" className="py-24 md:py-32 bg-[#fdf9f3]">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#C9A84C] text-sm tracking-[0.3em] uppercase mb-4" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
            Lo que ofrezco
          </p>
          <h2
            className="text-4xl md:text-5xl font-light text-[#1a1208]"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Mis <span className="italic text-[#C9A84C]">Servicios</span>
          </h2>
        </div>

        {/* Cards */}
        <div
          ref={ref}
          className={`grid grid-cols-1 md:grid-cols-3 gap-6 transition-all duration-1000 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
          data-product-shop
        >
          {services.map((service, idx) => (
            <div
              key={service.id}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
              style={{
                transitionDelay: `${idx * 150}ms`,
              }}
            >
              {/* Image */}
              <div className="w-full h-[420px] md:h-[480px]">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-black/10"></div>
              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-2 mb-3">
                  <span className="text-[#C9A84C]/80 text-xs tracking-widest uppercase">{service.duration}</span>
                  <span className="w-1 h-1 rounded-full bg-[#C9A84C]/50"></span>
                  <span className="text-[#C9A84C] text-sm font-semibold">{service.price}</span>
                </div>
                <h3
                  className="text-white text-xl font-light mb-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {service.title}
                </h3>
                <p className="text-[#e8dcc8]/70 text-sm leading-relaxed mb-5">
                  {service.description}
                </p>
                <button
                  onClick={handleContact}
                  className="bg-[#C9A84C] text-[#0d0a07] px-6 py-2 rounded-full text-sm font-semibold hover:bg-[#e0bc5e] transition-colors duration-200 cursor-pointer whitespace-nowrap"
                >
                  Reservar
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
